<template>
  <el-image style="width: 100px; height: 100px" :src="src" :fit="fit" v-bind="$attrs" v-on="$listeners">
    <template #placeholder>
      <div class="image-slot">加载中</div>
    </template>

    <template #error>
      <img :src="errImgSrc" alt="加载失败图片" style="width: 100%;">
    </template>
  </el-image>
</template>

<script>
import errImgSrc from '@/assets/images/no_image.png'
export default {
  name: 'HcImage',
  props: {
    src: {
      type: String
    },
    fit: {
      type: String,
      default: 'contain'
    },
    width: {
      type: String,
      default: '100px'
    },
    height: {
      type: String,
      default: '100px'
    }
  },
  data() {
    return {
      errImgSrc
    }
  }
}
</script>
